import { PlusCircle } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconPlusCircle(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <PlusCircle />
    </IconWrapper>
  );
}
